var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelephoneWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.928,
    height: 34,
    viewBox: "0 0 33.928 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KASOOKOO_BUSINESS_TELEPHONY",
    "data-name": "KASOOKOO BUSINESS TELEPHONY",
    transform: "translate(-0.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "translate(0.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19395",
    "data-name": "Path 19395",
    d: "M33.578,24.953l-4.745-4.745a3.156,3.156,0,0,0-5.253,1.186,3.229,3.229,0,0,1-3.728,2.033c-3.389-.847-7.964-5.253-8.812-8.812a3.071,3.071,0,0,1,2.033-3.728A3.156,3.156,0,0,0,14.26,5.634L9.515.89A3.384,3.384,0,0,0,4.94.89L1.72,4.109c-3.22,3.389.339,12.37,8.3,20.335s16.946,11.693,20.335,8.3l3.22-3.22A3.384,3.384,0,0,0,33.578,24.953Z",
    transform: "translate(-0.539 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneWhiteIcon);
export default __webpack_public_path__ + "static/media/telephone_white_icon.1bc0a773add29e7983bac39f2c1f29b9.svg";
export { ForwardRef as ReactComponent };